import { BaseEntity } from "yt-ng-framework";

export class KontniPlan extends BaseEntity{
    constructor(){
        super();
    }

    Konto: string = null;
    Naziv: string = null;
    ImaAna: boolean = null;
    NazivEn: string = null;
    VrstaKontnogPlanaID: number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Konto=input.Konto;
        this.Naziv=input.Naziv;
        this.ImaAna=input.ImaAna;
        this.NazivEn=input.NazivEn;
        this.VrstaKontnogPlanaID=input.VrstaKontnogPlanaID;
        return this;
    }
    Serialize(input:KontniPlan){
        input.ImaAna = input.ImaAna == null ? false : input.ImaAna;
        return input;
    }
}